<div class="jumping-dots-loader">
  <span></span>
  <span></span>
  <span></span>
</div>
